import React, { Component } from "react"
import PropTypes from "prop-types"

import searchifyActionTypes from "shared/search/searchify/action-types"

// components
import SelectOrEditSelection from "selects/components/SelectOrEditSelection"
import { SelectSearchBar as StyledSelectWrapper } from "quorumdesign"

// this Searchify Filter doesn't ever actually publish anything to the store;
// submitSearchifyFunc should take care of it.

export default class SearchifySelectFilter extends Component {
    constructor(props) {
        super(props)
        this.clearSearchifySelection = this.clearSearchifySelection.bind(this)
        this.updateSelect = this.updateSelect.bind(this)
    }

    getSearchifyConfigs() {
        const searchifyConfigs = {
            searchifyPermanentFilter: this.props.searchifyPermanentFilter,
            singleSelectSearchify: this.props.singleSelectSearchify || this.props.multi === false,
            submitSearchifyFunc: searchifyActionTypes.SELECT_SUBMIT_SEARCHIFY,
            searchifyHeaderName: "Power Search",
        }

        if (this.props.maxSearchifySelections) {
            searchifyConfigs.maxSearchifySelections = this.props.maxSearchifySelections
        }

        if (this.props.enableSelectAllActionButtonSearchify) {
            searchifyConfigs.enableSelectAllActionButtonSearchify = this.props.enableSelectAllActionButtonSearchify
        }

        return Object.assign({}, searchifyConfigs, {
            // our filter specific information
            searchifyInitialFilters: this.props.deserializedValue,
            searchifyFLV: this.props.searchifyFLV,
            searchifySubmitParams: {
                uniqueFilterIdToEdit: this.props.uniqueFilterId,
                uniqueFlvIdToEdit: this.props.uniqueFlvId,
            },
        })
    }

    clearSearchifySelection() {
        this.props.publishChange(undefined)
    }

    updateSelect(data) {
        if (!data) {
            return this.clearSearchifySelection()
        }

        const addedIds = this.props.multi ? data.map((obj) => obj.id) : [data.id]

        const updatedValue = addedIds.length
            ? {
                  addedIds,
                  deletedIds: [],
                  querysetList: [],
                  searchifyCount: addedIds.length,
              }
            : undefined

        this.props.publishChange(updatedValue)
    }

    render() {
        const Component = this.props.selectComponent
        return (
            <div className="filter-container">
                <StyledSelectWrapper>
                    <SelectOrEditSelection
                        clearSearchifySelection={this.clearSearchifySelection}
                        filterGroupIsOpen={this.props.filterGroupIsOpen}
                        multi={this.props.multi}
                        onChange={this.updateSelect}
                        permanentFilter={this.props.searchifyPermanentFilter}
                        searchify={this.props.showSelectSearchify}
                        searchifyConfigs={this.getSearchifyConfigs()}
                        selectComponent={(props) => <Component {...props} />}
                        value={this.props.deserializedValue}
                    />
                </StyledSelectWrapper>
            </div>
        )
    }
}

SearchifySelectFilter.propTypes = {
    dataTypeLabel: PropTypes.string,
    deserializedValue: PropTypes.object.isRequired,
    searchifyFLV: PropTypes.func,
    uniqueFilterId: PropTypes.string.isRequired,
    publishChange: PropTypes.func.isRequired,
    selectComponent: PropTypes.func.isRequired,
    showSelectSearchify: PropTypes.bool,
    // searchify option items
    singleSelectSearchify: PropTypes.bool,
    disableSelectAllSearchify: PropTypes.bool,
    searchifyInitialAddedIds: PropTypes.object,
    searchifyPermanentFilter: PropTypes.object,
    searchifyInitialFilter: PropTypes.object,
    singleFilterSearchify: PropTypes.bool,
    multi: PropTypes.bool,
    searchifyHeaderName: PropTypes.string,
    submitSearchifyFunc: PropTypes.func,
}

SearchifySelectFilter.defaultProps = {
    dataTypeLabel: "",
    multi: true,
    showSelectSearchify: true,
}
